import { render, staticRenderFns } from "./ImportProgressBarModal.vue?vue&type=template&id=4004974e&scoped=true&"
import script from "./ImportProgressBarModal.vue?vue&type=script&lang=js&"
export * from "./ImportProgressBarModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportProgressBarModal.vue?vue&type=style&index=0&id=4004974e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4004974e",
  null
  
)

export default component.exports